// Autogenerated file
export const mobileOsTypesEnum = {
    Android: "Android",
    iOS: "iOS",
};
export const mobileOsTypes = [
    { label: "Андроид", value: "Android" },
    { label: "iOS", value: "iOS" },
];
